import { render, staticRenderFns } from "./addksFileTable.vue?vue&type=template&id=24c226bf&scoped=true"
import script from "./addksFileTable.vue?vue&type=script&lang=js"
export * from "./addksFileTable.vue?vue&type=script&lang=js"
import style0 from "./addksFileTable.vue?vue&type=style&index=0&id=24c226bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c226bf",
  null
  
)

export default component.exports